import React from 'react';
import { philosophyData } from '../data/mock';

const PhilosophySection = () => {
  return (
    <section id="philosophy" className="py-24 md:py-32 bg-[#FAF8F5]">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        {/* Decorative element */}
        <div className="flex items-center justify-center gap-4 mb-10">
          <div className="w-12 h-px bg-[#D4AF37]" />
          <div className="w-2 h-2 bg-[#D4AF37] rotate-45" />
          <div className="w-12 h-px bg-[#D4AF37]" />
        </div>

        <h2 className="font-playfair text-4xl md:text-5xl text-[#1A2B3C] mb-8 leading-tight">
          {philosophyData.headline}
        </h2>

        <p className="font-lato text-lg text-[#1A2B3C]/70 leading-relaxed max-w-3xl mx-auto">
          {philosophyData.body}
        </p>

        {/* Bottom decorative line */}
        <div className="mt-12 flex justify-center">
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
